// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-user-section{
    width: 100%;
    margin-top: 15px;
    padding-bottom: 50px;
    height: 88vh;
    overflow-y: scroll;
}

.all-user-section .users-table {
    width: 1200px;
    /* max-width: 100%; */
}

.all-user-section .users-table .del-btn{
    background-color: transparent;
    border: none;
    cursor: pointer;
    width:37px;
    height: 37px;
    transition: var(--main-transition);
    border-radius: 50%;
}

.all-user-section .users-table .del-btn:hover{
    background-color: #EEE;

}

.all-user-section .users-table .del-btn svg {
    color: #dc3545;
    font-size: 17px;
    transition: var(--main-transition);
}

.all-user-section .users-table .table-head{
    background-color: white;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid #EEE;
    display: flex;
    align-items: center;
    padding: 8px 15px;
    justify-content: space-between;
} 
.all-user-section .users-table .table-head p{
    font-size: 15px;
    color: #303f53;
    font-weight: 700;
}

.all-user-section .users-table .table-head .cell ,
.all-user-section .users-table .table-body .cell {
    width: calc(100%  / 6);
    display: flex;
    justify-content: center;
    align-items: center;
}



.all-user-section .users-table .table-body .cell p{
    color: #667180;
    font-weight: 700;
    font-size: 15px;
    
}

.all-user-section .users-table .table-body .cell:last-child{
    border-bottom-right-radius:6px ;
    border-bottom-left-radius:6px ;
}


.all-user-section .users-table .table-body .cell img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 0px 7px;
}

.all-user-section .users-table .table-body .cell .active{
    padding: 5px 10px;
    border-radius: 22px;
    font-size: 13px;
    background-color: #ebf8f5;
    color: #28ad96;
}

.all-user-section .users-table .table-body .cell .point{
    padding: 0px 14px ;
    font-size: 13px;
    border-radius: 22px;
}

.all-user-section .users-table .table-body .cell .point-high{
    background-color: #d1fadf; 
    color: #1d6346;
}

.all-user-section .users-table .table-body .cell .point-low{
    background-color: #fee4e2;
    color: #954e43;
}

.all-user-section .users-table .table-body .cell .point-medium{
    background-color: #fef0c7;
    color: #a8755d;
}

.all-user-section .users-table .table-body .cell .slide{
width: 45px;
height: 20px;
border-radius: 22px;
position: relative;
padding: 0px 3px;
cursor: pointer;
}

.all-user-section .users-table .table-body .cell .active-slide {
    background-color: #036ae1;
}
.all-user-section .users-table .table-body .cell .not-slide{
    background-color: #6d6d73;
}

.all-user-section .users-table .table-body .cell .slide span{
    width: 15px;
    height: 15px;
    background-color: white;
    border-radius: 50%;
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
    transition: var(--main-transition);
}
.all-user-section .users-table .table-body .cell .slide span.ball-active{
    right: 5px;
}

.all-user-section .users-table .table-body .cell .slide span.ball-not-active{
    right: 25px;
}

.all-user-section .users-table .table-body .cell .not-active{
    padding: 5px 10px;
    border-radius: 22px;
    font-size: 13px;
    background-color: #f8ebeb;
    color: #f13c3c;
}

.all-user-section .users-table .row{
    background-color: white;
    border: 1px solid #EEE;
    display: flex;
    align-items: center;
    padding: 13px 12px;
    justify-content: space-between;
}

.all-user-section .users-table .row .cell .user-email{
    color: var(--gray-color);
    font-weight: 400;
    font-size: 13px;
}

.all-user-section .users-table .row .cell .manage-point-btn {
    background-color: #EEE;
    border-radius: 50%;
    border: none;
    padding: 5px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    margin: 0px 5px;
    transition: var(--main-transition);
}

.all-user-section .users-table .row .cell .manage-point-btn:hover{
    background-color: #e0dfdf;
}

.all-user-section .users-table .row .cell .manage-point-btn svg{
    color: #333;
    font-size: 11px;
}


.all-user-section .users-table .row .cell .edite-user-icon{
    color: #464545;
    cursor: pointer;
    /* width: 20px;
    height: 20px; */
    border-radius: 50%;
    transition: var(--main-transition);
    font-size: 12px ;
}

.all-user-section .users-table .row .cell .edite-user-icon:hover{
    background-color: #EEE;
    
}

.all-user-section .users-table .row .cell .btn-edit{
    width: 25px;
    height: 25px;
    text-align: center;
    display: inline-block;
    border-radius:50% ;
    transition: var(--main-transition);
    cursor: pointer;
}

.all-user-section .users-table .row .cell .btn-edit:hover{
    background-color: #EEE;
}


.all-user-section .tools{
    margin: 12px 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1200px;
    max-width: 100%;
}


.all-user-section .tools .right .add-user-btn{
    color: white;
    font-weight: bold;
    background-color: var(--main-color);
    border: none;
    padding: 10px 33px;
    border-radius:7px;
    cursor: pointer;
    transition: var(--main-transition);
}

.all-user-section .tools .right .add-user-btn:hover{
    opacity: .86;
}


.all-user-section .tools .left {
display: flex;
}

.all-user-section .tools .left .search-bar {
    background-color: white;
    width: 300px;
    border-radius:22px ;
    padding: 3px 9px;
} 

.all-user-section .tools .left .search-bar svg{
    width: 20px;
    color: var(--gray-color);
}

.all-user-section .tools .left .search-bar input{
    margin: 0px 5px; 
    border: none;
    width: calc(100% - 40px);
    transition: var(--main-transition);
}

.all-user-section .tools .left .search-bar input:focus{
    outline: none;
}

.all-user-section .tools .left .search-btn{
    background-color: var(--main-color);
    color: white;
    display: block;
    border: none;
    padding: 2px 25px;
    border-radius: 22px;
    margin-left: 6px;
    cursor: pointer;
    font-weight: bold;
    transition: var(--main-transition);
}

.all-user-section .tools .left .rest-btn {
    background-color: hsl(148, 70%, 31%);
    font-weight: bold;
    width: 100px;
    color: white;
    transition: var(--main-transition);
    cursor: pointer;
    border: none;
    margin: 0px 6px;
    border-radius: 22px;
    
}

.all-user-section .tools .left .rest-btn:hover{
    background-color: hsl(148, 74%, 37%);
}


.all-user-section .tools .left .search-btn:hover{
    opacity: .8;
}

.all-user-section .pag-con {
    display: flex;
    justify-content: center;
}



/* Start Edit User Model */

.edit-user-model{
    background-color: white;
    border: none;
    outline: none !important;
    height: 400px;
    border-radius: 20px;
    padding: 3px;
    overflow-y: scroll;
    max-width: 100%;

    font-family: "Cairo", serif;
}

.edit-user-model .edit-model-heaer{
    position: relative;

    padding-left: 30px;
    height: 190px;
    /* background-color: red; */
    display: flex;
    align-items: center;
    padding-inline-start: 30px;
}

.edit-user-model .edit-model-heaer .top-header{
    background-color: #f1f1f1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 90px;
    border-radius: 20px;
    border-end-start-radius: 0px;
    border-end-end-radius: 0px;
    z-index: 50;
}

.edit-user-model .edit-model-heaer .user-info{
    display: flex;
    margin-top: 30px;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 60;
}

.edit-user-model .edit-model-heaer .data-names{
    margin-top: 8px;
}

.edit-user-model .edit-model-heaer .data-names h3{
    font-size: 22px;
}

.edit-user-model .edit-model-heaer .data-names p{
    color: gray;
    font-size: 14px;
}

.edit-user-model .edit-model-heaer .user-info .user-image{
    padding: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 77px;
    height: 77px;
    border: 2px solid #EEE;
    border-radius:50% ;
    background-color: white;
    position: relative;
}
.edit-user-model .edit-model-heaer .user-info .user-image .verify-logo{
    position: absolute;
    width: 17px;
    height: 17px;
    right: 0;
    bottom: 3px;
}

.edit-user-model .edit-model-heaer .user-info .user-image img{
    width: 70px;
    height: 70px;
}


.edit-user-model .edit-form{
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 20px;
}

.edit-user-model .edit-form .row{

    border-top: 1px solid #dddddd;
    width: 90%;
    display: flex;
    justify-content: space-between;
    padding: 15px 0px;
}

.edit-user-model .edit-form .row label{
    font-weight: 700;
    color:#667180 ;
    font-size: 14px;
}

.edit-user-model .edit-form .row .input-data{
    width: 300px;
    max-width: 100%;
    border-radius:4px;
    border: 1px solid #d1d1d1;
    margin: 0px 5px;
}

.edit-user-model .edit-form .row .input-data input {
    width: 100%;
    border: none;
    color: #6d6d73;
    padding-left: 10px;
    padding-inline-start: 10px;
    font-weight: 500;
}

.edit-user-model .edit-form .row .input-data input:focus{
    outline: none;
}

.edit-user-model .edit-form .btns-edit{
    display: flex;
    align-items: center;
    padding-top: 20px;
    justify-content: space-between;
}

.edit-user-model .edit-form .btns-edit .delete-user-btn {
    background-color:#fdeced ;
    color: #822824;
    border: 1px solid #EEE;
    font-weight: bold;
    width: 120px;
    cursor: pointer;
    height: 35px;
    transition: var(--main-transition);
    border-radius: 5px;
}

.edit-user-model .edit-form .btns-edit .delete-user-btn:hover{
    opacity: .8;
}

.edit-user-model .edit-form .btns-edit .delete-user-btn svg{
color: #721c24;
margin: 0px 5px;
}

.edit-user-model .edit-form .btns-edit .cancel-btns{
    display: flex;
    align-items: center;
}
.edit-user-model .edit-form .btns-edit .cancel-btns button{
    margin:0px 10px;
}

.edit-user-model .edit-form .btns-edit .cancel-btns .cancel-btn {
    border:1px solid #cecccc;
    width: 80px;
    background-color: transparent;
    cursor: pointer;
    height: 35px;
    font-weight: bold;
    border-radius: 5px;
    transition: var(--main-transition);
}

.edit-user-model .edit-form .btns-edit .cancel-btns .cancel-btn:hover{
    opacity: .8;
}

.edit-user-model .edit-form .btns-edit .cancel-btns .save-btn{
    background-color:#1f1f1f ;
    border: none;
    border-radius: 5px;
    width: 120px;
    height: 35px;
    color: white;
    cursor: pointer;
    font-weight: bold;
    transition: var(--main-transition);
}

.edit-user-model .edit-form .btns-edit .cancel-btns .save-btn:hover{
    opacity: .8;
}

/* End Edit User Model */`, "",{"version":3,"sources":["webpack://./src/Pages/AllUsers/allusers.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,UAAU;IACV,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;;;AAIA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ,mBAAmB;AACnB,kBAAkB;AAClB,gBAAgB;AAChB,eAAe;AACf;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,kCAAkC;AACtC;AACA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,cAAc;IACd,eAAe;IACf;mBACe;IACf,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;;AAE1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,eAAe;AACnB;;;AAGA;IACI,YAAY;IACZ,iBAAiB;IACjB,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB;;;AAGA;AACA,aAAa;AACb;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,wBAAwB;IACxB,kCAAkC;AACtC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,YAAY;IACZ,eAAe;IACf,mBAAmB;;AAEvB;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;;;AAIA,0BAA0B;;AAE1B;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;;IAEf,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;;IAElB,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,4BAA4B;IAC5B,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,6BAA6B;IAC7B,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;AACA,cAAc;AACd,eAAe;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA,wBAAwB","sourcesContent":[".all-user-section{\n    width: 100%;\n    margin-top: 15px;\n    padding-bottom: 50px;\n    height: 88vh;\n    overflow-y: scroll;\n}\n\n.all-user-section .users-table {\n    width: 1200px;\n    /* max-width: 100%; */\n}\n\n.all-user-section .users-table .del-btn{\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    width:37px;\n    height: 37px;\n    transition: var(--main-transition);\n    border-radius: 50%;\n}\n\n.all-user-section .users-table .del-btn:hover{\n    background-color: #EEE;\n\n}\n\n.all-user-section .users-table .del-btn svg {\n    color: #dc3545;\n    font-size: 17px;\n    transition: var(--main-transition);\n}\n\n.all-user-section .users-table .table-head{\n    background-color: white;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    border: 1px solid #EEE;\n    display: flex;\n    align-items: center;\n    padding: 8px 15px;\n    justify-content: space-between;\n} \n.all-user-section .users-table .table-head p{\n    font-size: 15px;\n    color: #303f53;\n    font-weight: 700;\n}\n\n.all-user-section .users-table .table-head .cell ,\n.all-user-section .users-table .table-body .cell {\n    width: calc(100%  / 6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n\n\n.all-user-section .users-table .table-body .cell p{\n    color: #667180;\n    font-weight: 700;\n    font-size: 15px;\n    \n}\n\n.all-user-section .users-table .table-body .cell:last-child{\n    border-bottom-right-radius:6px ;\n    border-bottom-left-radius:6px ;\n}\n\n\n.all-user-section .users-table .table-body .cell img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    margin: 0px 7px;\n}\n\n.all-user-section .users-table .table-body .cell .active{\n    padding: 5px 10px;\n    border-radius: 22px;\n    font-size: 13px;\n    background-color: #ebf8f5;\n    color: #28ad96;\n}\n\n.all-user-section .users-table .table-body .cell .point{\n    padding: 0px 14px ;\n    font-size: 13px;\n    border-radius: 22px;\n}\n\n.all-user-section .users-table .table-body .cell .point-high{\n    background-color: #d1fadf; \n    color: #1d6346;\n}\n\n.all-user-section .users-table .table-body .cell .point-low{\n    background-color: #fee4e2;\n    color: #954e43;\n}\n\n.all-user-section .users-table .table-body .cell .point-medium{\n    background-color: #fef0c7;\n    color: #a8755d;\n}\n\n.all-user-section .users-table .table-body .cell .slide{\nwidth: 45px;\nheight: 20px;\nborder-radius: 22px;\nposition: relative;\npadding: 0px 3px;\ncursor: pointer;\n}\n\n.all-user-section .users-table .table-body .cell .active-slide {\n    background-color: #036ae1;\n}\n.all-user-section .users-table .table-body .cell .not-slide{\n    background-color: #6d6d73;\n}\n\n.all-user-section .users-table .table-body .cell .slide span{\n    width: 15px;\n    height: 15px;\n    background-color: white;\n    border-radius: 50%;\n    position: absolute;\n    right: 5px;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: var(--main-transition);\n}\n.all-user-section .users-table .table-body .cell .slide span.ball-active{\n    right: 5px;\n}\n\n.all-user-section .users-table .table-body .cell .slide span.ball-not-active{\n    right: 25px;\n}\n\n.all-user-section .users-table .table-body .cell .not-active{\n    padding: 5px 10px;\n    border-radius: 22px;\n    font-size: 13px;\n    background-color: #f8ebeb;\n    color: #f13c3c;\n}\n\n.all-user-section .users-table .row{\n    background-color: white;\n    border: 1px solid #EEE;\n    display: flex;\n    align-items: center;\n    padding: 13px 12px;\n    justify-content: space-between;\n}\n\n.all-user-section .users-table .row .cell .user-email{\n    color: var(--gray-color);\n    font-weight: 400;\n    font-size: 13px;\n}\n\n.all-user-section .users-table .row .cell .manage-point-btn {\n    background-color: #EEE;\n    border-radius: 50%;\n    border: none;\n    padding: 5px;\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n    margin: 0px 5px;\n    transition: var(--main-transition);\n}\n\n.all-user-section .users-table .row .cell .manage-point-btn:hover{\n    background-color: #e0dfdf;\n}\n\n.all-user-section .users-table .row .cell .manage-point-btn svg{\n    color: #333;\n    font-size: 11px;\n}\n\n\n.all-user-section .users-table .row .cell .edite-user-icon{\n    color: #464545;\n    cursor: pointer;\n    /* width: 20px;\n    height: 20px; */\n    border-radius: 50%;\n    transition: var(--main-transition);\n    font-size: 12px ;\n}\n\n.all-user-section .users-table .row .cell .edite-user-icon:hover{\n    background-color: #EEE;\n    \n}\n\n.all-user-section .users-table .row .cell .btn-edit{\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    display: inline-block;\n    border-radius:50% ;\n    transition: var(--main-transition);\n    cursor: pointer;\n}\n\n.all-user-section .users-table .row .cell .btn-edit:hover{\n    background-color: #EEE;\n}\n\n\n.all-user-section .tools{\n    margin: 12px 2px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 1200px;\n    max-width: 100%;\n}\n\n\n.all-user-section .tools .right .add-user-btn{\n    color: white;\n    font-weight: bold;\n    background-color: var(--main-color);\n    border: none;\n    padding: 10px 33px;\n    border-radius:7px;\n    cursor: pointer;\n    transition: var(--main-transition);\n}\n\n.all-user-section .tools .right .add-user-btn:hover{\n    opacity: .86;\n}\n\n\n.all-user-section .tools .left {\ndisplay: flex;\n}\n\n.all-user-section .tools .left .search-bar {\n    background-color: white;\n    width: 300px;\n    border-radius:22px ;\n    padding: 3px 9px;\n} \n\n.all-user-section .tools .left .search-bar svg{\n    width: 20px;\n    color: var(--gray-color);\n}\n\n.all-user-section .tools .left .search-bar input{\n    margin: 0px 5px; \n    border: none;\n    width: calc(100% - 40px);\n    transition: var(--main-transition);\n}\n\n.all-user-section .tools .left .search-bar input:focus{\n    outline: none;\n}\n\n.all-user-section .tools .left .search-btn{\n    background-color: var(--main-color);\n    color: white;\n    display: block;\n    border: none;\n    padding: 2px 25px;\n    border-radius: 22px;\n    margin-left: 6px;\n    cursor: pointer;\n    font-weight: bold;\n    transition: var(--main-transition);\n}\n\n.all-user-section .tools .left .rest-btn {\n    background-color: hsl(148, 70%, 31%);\n    font-weight: bold;\n    width: 100px;\n    color: white;\n    transition: var(--main-transition);\n    cursor: pointer;\n    border: none;\n    margin: 0px 6px;\n    border-radius: 22px;\n    \n}\n\n.all-user-section .tools .left .rest-btn:hover{\n    background-color: hsl(148, 74%, 37%);\n}\n\n\n.all-user-section .tools .left .search-btn:hover{\n    opacity: .8;\n}\n\n.all-user-section .pag-con {\n    display: flex;\n    justify-content: center;\n}\n\n\n\n/* Start Edit User Model */\n\n.edit-user-model{\n    background-color: white;\n    border: none;\n    outline: none !important;\n    height: 400px;\n    border-radius: 20px;\n    padding: 3px;\n    overflow-y: scroll;\n    max-width: 100%;\n\n    font-family: \"Cairo\", serif;\n}\n\n.edit-user-model .edit-model-heaer{\n    position: relative;\n\n    padding-left: 30px;\n    height: 190px;\n    /* background-color: red; */\n    display: flex;\n    align-items: center;\n    padding-inline-start: 30px;\n}\n\n.edit-user-model .edit-model-heaer .top-header{\n    background-color: #f1f1f1;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 90px;\n    border-radius: 20px;\n    border-end-start-radius: 0px;\n    border-end-end-radius: 0px;\n    z-index: 50;\n}\n\n.edit-user-model .edit-model-heaer .user-info{\n    display: flex;\n    margin-top: 30px;\n    flex-direction: column;\n    justify-content: center;\n    position: relative;\n    z-index: 60;\n}\n\n.edit-user-model .edit-model-heaer .data-names{\n    margin-top: 8px;\n}\n\n.edit-user-model .edit-model-heaer .data-names h3{\n    font-size: 22px;\n}\n\n.edit-user-model .edit-model-heaer .data-names p{\n    color: gray;\n    font-size: 14px;\n}\n\n.edit-user-model .edit-model-heaer .user-info .user-image{\n    padding: 4px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 77px;\n    height: 77px;\n    border: 2px solid #EEE;\n    border-radius:50% ;\n    background-color: white;\n    position: relative;\n}\n.edit-user-model .edit-model-heaer .user-info .user-image .verify-logo{\n    position: absolute;\n    width: 17px;\n    height: 17px;\n    right: 0;\n    bottom: 3px;\n}\n\n.edit-user-model .edit-model-heaer .user-info .user-image img{\n    width: 70px;\n    height: 70px;\n}\n\n\n.edit-user-model .edit-form{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 20px;\n}\n\n.edit-user-model .edit-form .row{\n\n    border-top: 1px solid #dddddd;\n    width: 90%;\n    display: flex;\n    justify-content: space-between;\n    padding: 15px 0px;\n}\n\n.edit-user-model .edit-form .row label{\n    font-weight: 700;\n    color:#667180 ;\n    font-size: 14px;\n}\n\n.edit-user-model .edit-form .row .input-data{\n    width: 300px;\n    max-width: 100%;\n    border-radius:4px;\n    border: 1px solid #d1d1d1;\n    margin: 0px 5px;\n}\n\n.edit-user-model .edit-form .row .input-data input {\n    width: 100%;\n    border: none;\n    color: #6d6d73;\n    padding-left: 10px;\n    padding-inline-start: 10px;\n    font-weight: 500;\n}\n\n.edit-user-model .edit-form .row .input-data input:focus{\n    outline: none;\n}\n\n.edit-user-model .edit-form .btns-edit{\n    display: flex;\n    align-items: center;\n    padding-top: 20px;\n    justify-content: space-between;\n}\n\n.edit-user-model .edit-form .btns-edit .delete-user-btn {\n    background-color:#fdeced ;\n    color: #822824;\n    border: 1px solid #EEE;\n    font-weight: bold;\n    width: 120px;\n    cursor: pointer;\n    height: 35px;\n    transition: var(--main-transition);\n    border-radius: 5px;\n}\n\n.edit-user-model .edit-form .btns-edit .delete-user-btn:hover{\n    opacity: .8;\n}\n\n.edit-user-model .edit-form .btns-edit .delete-user-btn svg{\ncolor: #721c24;\nmargin: 0px 5px;\n}\n\n.edit-user-model .edit-form .btns-edit .cancel-btns{\n    display: flex;\n    align-items: center;\n}\n.edit-user-model .edit-form .btns-edit .cancel-btns button{\n    margin:0px 10px;\n}\n\n.edit-user-model .edit-form .btns-edit .cancel-btns .cancel-btn {\n    border:1px solid #cecccc;\n    width: 80px;\n    background-color: transparent;\n    cursor: pointer;\n    height: 35px;\n    font-weight: bold;\n    border-radius: 5px;\n    transition: var(--main-transition);\n}\n\n.edit-user-model .edit-form .btns-edit .cancel-btns .cancel-btn:hover{\n    opacity: .8;\n}\n\n.edit-user-model .edit-form .btns-edit .cancel-btns .save-btn{\n    background-color:#1f1f1f ;\n    border: none;\n    border-radius: 5px;\n    width: 120px;\n    height: 35px;\n    color: white;\n    cursor: pointer;\n    font-weight: bold;\n    transition: var(--main-transition);\n}\n\n.edit-user-model .edit-form .btns-edit .cancel-btns .save-btn:hover{\n    opacity: .8;\n}\n\n/* End Edit User Model */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
